import {
    REQUEST_SCAN_CARD,
    REQUEST_SCAN_CARD_CANCELLED,
    REQUEST_SCAN_CARD_DONE,
    REQUEST_SCAN_CARD_FAILED,
    REQUEST_SCAN_CARD_SUCCEEDED,
    SCAN_CARD_CHOOSE_CARRIER,
    SCAN_CARD_CHOOSE_PLAN,
    SCAN_CARD_REPICK_CARRIER,
    PRIVACY_CHECKBOX_CLICKED,
    PRIVACY_DIALOG_DISMISS,
    SCAN_CARD_CAPTURED_FRONT_CARD,
    EDIT_SCAN_CARD_CARRIER,
    EDIT_SCAN_CARD_PLAN,
    CANCEL_EDIT_SCAN_CARD,
} from '../../components/ScanCard/ScanCardActions';
import invariant from 'invariant';

export const SCAN_CARD_STATUS_INITIAL = 'initial';
export const SCAN_CARD_STATUS_LOADING = 'loading';
export const SCAN_CARD_STATUS_SUCCESS = 'success';

export const InitialState = {
    status: SCAN_CARD_STATUS_INITIAL,
    imageFront: null,
    frontCardUploaded: false,
    predictions: null,
    isPrivacyPolicyCheckboxChecked: true,
    isPrivacyDialogOpen: false,
    selectedInsurance: null,
    repickCarrier: false,
    correlation_id: null,
    carrierPositionSelectedByPatient: -1,
    planPositionSelectedByPatient: -1,
};

export function scanCardReducer(state, action) {
    const {
        type,
        payload,
    } = action;

    state = state || InitialState;

    switch (type) {
        case SCAN_CARD_CAPTURED_FRONT_CARD:
            return {
                ...state,
                frontCardUploaded: true,
            };

        case EDIT_SCAN_CARD_CARRIER:
            return {
                ...state,
                editingCarrier: true,
                editingPlan: false,
            };

        case EDIT_SCAN_CARD_PLAN:
            return {
                ...state,
                editingCarrier: false,
                editingPlan: true,
            };

        case CANCEL_EDIT_SCAN_CARD:
            return {
                ...state,
                editingCarrier: false,
                editingPlan: false,
            };

        case REQUEST_SCAN_CARD:
            return {
                ...state,
                status: SCAN_CARD_STATUS_LOADING,
                imageFront: payload.imageFront,
                predictions: null,
                repickCarrier: false,
                selectedInsurance: null,
                correlation_id: null,
                carrierPositionSelectedByPatient: -1,
                planPositionSelectedByPatient: -1,
                editingCarrier: false,
                editingPlan: false,
            };

        case REQUEST_SCAN_CARD_SUCCEEDED:
            return {
                ...state,
                status: SCAN_CARD_STATUS_SUCCESS,
                predictions: payload.response.insurances,
                correlation_id: payload.response.correlation_id,
            };

        case REQUEST_SCAN_CARD_FAILED: // when the card scan fails, we kick them out. so reset everything
            return {
                ...state,
                status: SCAN_CARD_STATUS_INITIAL,
                predictions: null,
                imageFront: null,
                frontCardUploaded: false,
                selectedInsurance: null,
                repickCarrier: false,
                correlation_id: null,
                carrierPositionSelectedByPatient: -1,
                planPositionSelectedByPatient: -1,
                editingCarrier: false,
                editingPlan: false,
            };


        case REQUEST_SCAN_CARD_DONE: // user selected a carrier and plan, clear out all state
        case REQUEST_SCAN_CARD_CANCELLED: // user clicked the X or 'i don't see my plan', clear out all state
            return {
                ...state,
                status: SCAN_CARD_STATUS_INITIAL,
                predictions: null,
                imageFront: null,
                frontCardUploaded: false,
                selectedInsurance: null,
                selectedPlan: null,
                repickCarrier: false,
                editingCarrier: false,
                editingPlan: false,
                carrierPositionSelectedByPatient: state.autoSelectCarrier ? -1 : state.carrierPositionSelectedByPatient,
                planPositionSelectedByPatient: state.autoSelectPlan ? -1 : state.planPositionSelectedByPatient,
            };

        case PRIVACY_CHECKBOX_CLICKED: {
            const privacyPolicyCheckboxTransitioningToUnchecked = state.isPrivacyPolicyCheckboxChecked;
            const isPrivacyDialogClosed = !state.isPrivacyDialogOpen;
            const privacyDialogShouldBeOpen = privacyPolicyCheckboxTransitioningToUnchecked && isPrivacyDialogClosed;

            return {
                ...state,
                isPrivacyPolicyCheckboxChecked: !state.isPrivacyPolicyCheckboxChecked,
                isPrivacyDialogOpen: privacyDialogShouldBeOpen,
            };
        }

        case PRIVACY_DIALOG_DISMISS:
            return {
                ...state,
                isPrivacyDialogOpen: false,
            };


        case SCAN_CARD_REPICK_CARRIER: {
            return {
                ...state,
                repickCarrier: true,
                editingCarrier: false,
                editingPlan: false,
            };
        }

        case SCAN_CARD_CHOOSE_CARRIER: {
            const { insurance } = payload;
            invariant(insurance, 'insurance must be in the payload');
            invariant(insurance.carrier, 'carrier must be in the payload');
            invariant(insurance.carrier.hasOwnProperty('confidence'), 'carrier must have confidence');
            invariant(insurance.carrier.hasOwnProperty('carrier_id'), 'carrier must have carrier_id');
            invariant(insurance.carrier.hasOwnProperty('carrier_name'), 'carrier must have carrier_name');

            return {
                ...state,
                selectedPlan: null,
                selectedInsurance: insurance,
                repickCarrier: false,
                carrierPositionSelectedByPatient: payload.position,
                editingCarrier: false,
                editingPlan: false,
                autoSelectCarrier: payload.autoSelectCarrier,
            };
        }

        case SCAN_CARD_CHOOSE_PLAN: {
            return {
                ...state,
                selectedInsurance: payload.insurance,
                selectedPlan: payload.plan,
                planPositionSelectedByPatient: payload.position,
                editingCarrier: false,
                editingPlan: false,
                autoSelectPlan: payload.autoSelectPlan,
            };
        }

        default:
            return state;
    }
}
